// extracted by mini-css-extract-plugin
export default {"imageRow":"PrintForm_imageRow__OswR9","mockupFileContainer":"PrintForm_mockupFileContainer__uCk9o"};